var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNegativeSentiment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3832 0 0 5.3832 0 12C0 18.6168 5.3832 24 12 24C18.6168 24 24 18.6168 24 12C24 5.3832 18.6169 0 12 0ZM12 21.8182C6.58625 21.8182 2.18182 17.4138 2.18182 12C2.18182 6.58618 6.58625 2.18182 12 2.18182C17.4137 2.18182 21.8182 6.58625 21.8182 12C21.8182 17.4137 17.4137 21.8182 12 21.8182Z",
    fill: "#F5222D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.078C11.9998 13.078 12 13.078 11.9999 13.078C10.3099 13.078 8.72087 13.7362 7.52589 14.9313C7.09985 15.3572 7.09985 16.048 7.52589 16.474C7.73891 16.6871 8.0181 16.7936 8.2973 16.7936C8.5765 16.7936 8.85571 16.6871 9.06865 16.474C9.85163 15.6911 10.8926 15.2599 11.9999 15.2599C13.1072 15.2599 14.1482 15.6911 14.9312 16.474C15.3572 16.9 16.0479 16.9 16.474 16.474C16.9 16.0481 16.9 15.3573 16.474 14.9313C15.2789 13.7362 13.69 13.078 11.9999 13.078Z",
    fill: "#F5222D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37381 10.7011C8.64508 10.4305 8.79999 10.0553 8.79999 9.67273C8.79999 9.29019 8.64508 8.91491 8.37381 8.64429C8.10326 8.37382 7.72799 8.21819 7.34545 8.21819C6.96217 8.21819 6.58763 8.37382 6.31708 8.64429C6.04654 8.91491 5.8909 9.29019 5.8909 9.67273C5.8909 10.0553 6.04654 10.4305 6.31708 10.7011C6.58763 10.9716 6.9629 11.1273 7.34545 11.1273C7.72799 11.1273 8.10326 10.9716 8.37381 10.7011Z",
    fill: "#F5222D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6546 8.21819C16.2713 8.21819 15.8967 8.37382 15.6262 8.64429C15.3549 8.91491 15.2 9.29019 15.2 9.67273C15.2 10.0553 15.3549 10.4305 15.6262 10.7011C15.8967 10.9716 16.272 11.1273 16.6546 11.1273C17.0371 11.1273 17.4124 10.9716 17.6829 10.7011C17.9542 10.4305 18.1091 10.0553 18.1091 9.67273C18.1091 9.29019 17.9542 8.91491 17.6829 8.64429C17.4124 8.37382 17.0371 8.21819 16.6546 8.21819Z",
    fill: "#F5222D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeSentiment);
export default __webpack_public_path__ + "static/media/negativeSentiment.00e4040c6bbbe66d4d71d911d51fba95.svg";
export { ForwardRef as ReactComponent };